import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment as ENV } from '../../environments/environment';
import { ApiEndpoints as API } from '../../config/api-endpoints';
 
@Injectable({
  providedIn: 'root'
})
export class FlexAppService {
 
  constructor(private http: HttpClient) { }
 
  private getAuthOptions() {
    let token = '';
    try {
      const sessionData = sessionStorage.getItem('data');
      if (sessionData) {
        const parsedSession = JSON.parse(sessionData);
        token = parsedSession.__raw || parsedSession.token || '';
      }
    } catch (error) {
      console.error('Error retrieving session token for FlexAppService:', error);
    }
 
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    };
  }
 
  public retrieveCbpPolicy(request: any): Observable<any> {
    return this.http.post<any>(
      `${ENV.baseUrl.api}${API.CBP_RETRIEVE_POLICY}`,
      request,
      this.getAuthOptions()
    );
  }
 
}